import type { RelatedProblemKind } from '@/lib/coaching/related-problems-query'

/**
 * The one heading style every section of the admin card-details modal uses
 * (`SectionHeading` in `card-details-modal.tsx`, and `ProblemHistorySection`
 * standing outside that file's own module). Shared from here rather than
 * duplicated so the two can't drift out of visual sync silently.
 */
export const HEADING_CLASS =
  'text-[10px] font-bold tracking-wide text-(--cd-text-faint) uppercase'

/**
 * The word for each `RelatedProblemKind` (LG-360 §8, expert review B5).
 *
 * `related-problem-chips.tsx`'s `chipLabel` and `related-problem-modal.tsx`'s
 * heading used to hand-duplicate these two strings independently — a
 * two-armed ternary in one, a `Record` in the other. Adding a member to
 * `problemLinkKindEnum` (which widens `RelatedProblemKind`) type-checked
 * straight through the ternary's silent `else` and rendered the new kind as
 * "Variant: <title>", with no compile error anywhere. A `Record` requires
 * every union member as a key, so hoisting the one definition here — and
 * having both call sites index it instead of restating it — turns that gap
 * into a compile error in the one place it can happen, and makes it
 * impossible for the chip and the modal to disagree on the word.
 */
export const RELATED_KIND_LABEL: Record<RelatedProblemKind, string> = {
  duplicate: 'Duplicate',
  variant: 'Variant',
  series: 'Series',
}
